/*global angular*/
var selectionChartModule = angular.module('selectionChart', ['chart.js']);
selectionChartModule.directive('selectionChart', ['$q', 'curriculumManager', function ($q, CurriculumManager) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./selectionChart.html'),
    replace: true,
    transclude: true,
    scope: {
      fieldCounts: '='
    },
    //require: [ '^xyz' ], //requires a controller from the parent scope
    link: function (scope, element, attrs) {
      var chartOptions = {
        segmentShowStroke: true,
        segmentStrokeColor: '#fff',
        segmentStrokeWidth: 2,
        //animations
        animation: false,
        animationSteps: 170,
        animationEasing: 'easeOutBounce',
        animateRotate: false,
        animateScale: false,
        //tooltips
        showTooltips: false,
        tooltipFillColor: '#344154',
        tooltipFontFamily: 'Roboto',
        tooltipFontSize: 13,
        tooltipFontColor: '#fff',
        tooltipYPadding: 8,
        tooltipXPadding: 10,
        tooltipCornerRadius: 2,
        tooltipTitleFontFamily: 'Roboto'
      };

      console.log(scope.fieldCounts);
      //--------------- CHART FUNCTIONS ---------------------------------------//
      var getCount = function (field) {
        console.log(scope.fieldCounts[field.key]);
        console.log(field.key);
        var count = scope.fieldCounts[field.key] || 0;
        if (count > 5) {
          return {
            count: 5,
            field: field
          };
        } else {
          return {
            count: count,
            field: field
          };
        }
      };

      var getReverseCount = function (field) {
        var count = scope.fieldCounts[field.key] || 0;
        if (count > 5) {
          return {
            count: 0,
            field: field
          };
        } else {
          return {
            count: 5 - count,
            field: field
          };
        }
      };

      var getChartData = function (fields) {
        var i;
        var chartData = [];
        var result;
        var addChartDataForField = function (field) {
          result = getCount(field);
          chartData.push({
            value: result.count,
            color: result.field.color,
            highlight: result.field.color,
            label: result.field.title + ' ingevuld'
          });
          result = getReverseCount(field);
          chartData.push({
            value: result.count,
            color: '#f2f2f2',
            highlight: '#f2f2f2',
            label: result.field.title + ' grijs'
          });
        };
        for (i = 0; i < fields.length; i++) {
          addChartDataForField(fields[i]);
        }
        return chartData;
      };


      var recalcCultureChartData = function () {
        var defer = $q.defer();
        var chartData;
        CurriculumManager.getCultuurFields().then(function (fields) {
          chartData = getChartData(fields);
          defer.resolve({
            data: chartData.map(function (a) {
              return a.value;
            }),
            colors: chartData.map(function (a) {
              return a.color;
            }),
            labels: chartData.map(function (a) {
              return a.label;
            })
          });
        });
        return defer.promise;
      };

      var recalcPersonChartData = function () {
        var defer = $q.defer();
        var chartData;
        CurriculumManager.getPersoonsFields().then(function (fields) {
          chartData = getChartData(fields);
          defer.resolve({
            data: chartData.map(function (a) {
              return a.value;
            }),
            colors: chartData.map(function (a) {
              return a.color;
            }),
            labels: chartData.map(function (a) {
              return a.label;
            })
          });
        });
        return defer.promise;
      };

      recalcPersonChartData().then(function (data) {
        scope.personChartData = data;
        console.log(scope.personChartData);
      });

      recalcCultureChartData().then(function (data) {
        scope.cultureChartData = data;
      });


      /*      scope.cultureChartData = selectionManager.cultureChartData;
      */
      scope.cultureChartOptions = angular.copy(chartOptions);
      scope.cultureChartOptions.percentageInnerCutout = 70;


      scope.personChartOptions = angular.copy(chartOptions);
      scope.personChartOptions.percentageInnerCutout = 50;
    }
  };
}]);
module.exports = selectionChartModule;



// WEBPACK FOOTER //
// ./web/js/module/selection-chart/selectionChart.js